export function groupShowBack(group: {
  parentId?: string | null;
  parent?: { id?: string; name?: string } | null;
}): { to: string; label: string } {
  const parentId = group.parent?.id || group.parentId;
  if (parentId) {
    return { to: `/grupos/${parentId}`, label: 'Volver al grupo padre' };
  }
  return { to: '/grupos', label: 'Volver a grupos' };
}
